export const useModifiers = (styles = {}, base, mods) => {
    return Object.keys(mods).reduce((accumulator, mod) => {
        if (!mods[mod]) return accumulator;
        return `${accumulator} ${styles[`${base}_${mod}`]}`;
    }, '');
};
